const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|1?\d?\d)){3}$/),
);

console.log('isLocalhost:-----------------',isLocalhost)
import env from "./env";
export function register() {
  // if (process.env.NODE_ENV !== "production") return;
  console.log('"serviceWorker" in navigator:------------',"serviceWorker" in navigator)
  if ("serviceWorker" in navigator) {
    const swUrl = `${env.PUBLIC_URL? env.PUBLIC_URL:''}/service-worker.js`;

    console.log('swUrl:-------',swUrl);

    window.addEventListener("load", () => {
      if (isLocalhost) {
            console.log('in event listener:-------',swUrl)

        checkValidServiceWorker(swUrl);
        navigator.serviceWorker.ready.then(() => {});
      } else {
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker.register(swUrl).then((response)=>{
    console.warn('after service worker register:--------',response)
  }).catch(() => {});
}

function checkValidServiceWorker(swUrl) {
  console.log('in checkValidServiceWorker:------',swUrl)
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      console.log('response:--------',response)
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {});
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch(() => {});
  }
}
